module.exports = __webpack_public_path__ + "static/media/gloomy-sad.976d3790.png";